//
//
//
//

export default {
  name: 'urlView',
  data(){
    return{
      url:this.$route.query.url,
    }
  },
  mounted () {
    document.title = this.$route.query.title || '';
    document.documentElement.scrollTop = 0;
  },
}



// WEBPACK FOOTER //
// ./src/components/urlView.vue